/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import MaterialProperty from './MaterialProperty';

/**
 * The ManagerAccountControllerDtoLoginInfoResponse model module.
 * @module model/ManagerAccountControllerDtoLoginInfoResponse
 * @version 1.0
 */
class ManagerAccountControllerDtoLoginInfoResponse {
    /**
     * Constructs a new <code>ManagerAccountControllerDtoLoginInfoResponse</code>.
     * @alias module:model/ManagerAccountControllerDtoLoginInfoResponse
     */
    constructor() { 
        
        ManagerAccountControllerDtoLoginInfoResponse.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>ManagerAccountControllerDtoLoginInfoResponse</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/ManagerAccountControllerDtoLoginInfoResponse} obj Optional instance to populate.
     * @return {module:model/ManagerAccountControllerDtoLoginInfoResponse} The populated <code>ManagerAccountControllerDtoLoginInfoResponse</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new ManagerAccountControllerDtoLoginInfoResponse();

            if (data.hasOwnProperty('resultCode')) {
                obj['resultCode'] = ApiClient.convertToType(data['resultCode'], 'Number');
            }
            if (data.hasOwnProperty('code')) {
                obj['code'] = ApiClient.convertToType(data['code'], 'String');
            }
            if (data.hasOwnProperty('description')) {
                obj['description'] = ApiClient.convertToType(data['description'], 'String');
            }
            if (data.hasOwnProperty('errorCode')) {
                obj['errorCode'] = ApiClient.convertToType(data['errorCode'], 'Number');
            }
            if (data.hasOwnProperty('contentsReward')) {
                obj['contentsReward'] = ApiClient.convertToType(data['contentsReward'], [MaterialProperty]);
            }
            if (data.hasOwnProperty('name')) {
                obj['name'] = ApiClient.convertToType(data['name'], 'String');
            }
            if (data.hasOwnProperty('email')) {
                obj['email'] = ApiClient.convertToType(data['email'], 'String');
            }
            if (data.hasOwnProperty('departmentName')) {
                obj['departmentName'] = ApiClient.convertToType(data['departmentName'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>ManagerAccountControllerDtoLoginInfoResponse</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>ManagerAccountControllerDtoLoginInfoResponse</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['code'] && !(typeof data['code'] === 'string' || data['code'] instanceof String)) {
            throw new Error("Expected the field `code` to be a primitive type in the JSON string but got " + data['code']);
        }
        // ensure the json data is a string
        if (data['description'] && !(typeof data['description'] === 'string' || data['description'] instanceof String)) {
            throw new Error("Expected the field `description` to be a primitive type in the JSON string but got " + data['description']);
        }
        if (data['contentsReward']) { // data not null
            // ensure the json data is an array
            if (!Array.isArray(data['contentsReward'])) {
                throw new Error("Expected the field `contentsReward` to be an array in the JSON data but got " + data['contentsReward']);
            }
            // validate the optional field `contentsReward` (array)
            for (const item of data['contentsReward']) {
                MaterialProperty.validateJSON(item);
            };
        }
        // ensure the json data is a string
        if (data['name'] && !(typeof data['name'] === 'string' || data['name'] instanceof String)) {
            throw new Error("Expected the field `name` to be a primitive type in the JSON string but got " + data['name']);
        }
        // ensure the json data is a string
        if (data['email'] && !(typeof data['email'] === 'string' || data['email'] instanceof String)) {
            throw new Error("Expected the field `email` to be a primitive type in the JSON string but got " + data['email']);
        }
        // ensure the json data is a string
        if (data['departmentName'] && !(typeof data['departmentName'] === 'string' || data['departmentName'] instanceof String)) {
            throw new Error("Expected the field `departmentName` to be a primitive type in the JSON string but got " + data['departmentName']);
        }

        return true;
    }


}



/**
 * @member {Number} resultCode
 */
ManagerAccountControllerDtoLoginInfoResponse.prototype['resultCode'] = undefined;

/**
 * @member {String} code
 */
ManagerAccountControllerDtoLoginInfoResponse.prototype['code'] = undefined;

/**
 * @member {String} description
 */
ManagerAccountControllerDtoLoginInfoResponse.prototype['description'] = undefined;

/**
 * @member {Number} errorCode
 */
ManagerAccountControllerDtoLoginInfoResponse.prototype['errorCode'] = undefined;

/**
 * @member {Array.<module:model/MaterialProperty>} contentsReward
 */
ManagerAccountControllerDtoLoginInfoResponse.prototype['contentsReward'] = undefined;

/**
 * @member {String} name
 */
ManagerAccountControllerDtoLoginInfoResponse.prototype['name'] = undefined;

/**
 * @member {String} email
 */
ManagerAccountControllerDtoLoginInfoResponse.prototype['email'] = undefined;

/**
 * @member {String} departmentName
 */
ManagerAccountControllerDtoLoginInfoResponse.prototype['departmentName'] = undefined;






export default ManagerAccountControllerDtoLoginInfoResponse;

